import styles from "../../styles/Header.module.scss";

export default () => {
  return (
    <header className={ styles.header }>
      kpmTicketWriter
    </header>
  );
}